import styled from '@emotion/styled';

export const Container = styled.div`
  height: 3000px;
`;

export const WidgetContainer2 = styled.div`
  margin-top: 5.375rem;
  display: flex;
  width: 100%;
  position: relative;
  flex-direction: row;
  -webkit-box-pack: justify;
  justify-content: space-between;
  min-height: calc(100vh - 5.375rem);
  overflow: hidden;
`;

export const WidgetContainer = styled.div`
  position: absolute;
  bottom: 0;
  height: 600px;
  right: 0;
  width: 900px;
  border: 1px solid #000;
`;

export const LeftPanel = styled.div`
  background-color: #f7f7f7;
  position: absolute;
  left: 0;
  top: 0;
  width: 585px;
  height: 600px;
`;

export const RightPanel = styled.div`
  background-color: red;
  position: absolute;
  right: 0;
  top: -300px;
  width: 314px;
  height: calc(100vh - 300px);
  z-index: 99;
  border-left: 1px solid rgb(204, 204, 204);
`;

export const RightPanel2 = styled.div`
  width: 35vw;
  height: calc(100vh - 5.375rem);
  position: fixed;
  right: 0px;
  z-index: 99;
  border-left: 1px solid rgb(204, 204, 204);
  transition: all 500ms ease 0s;
  background: rgb(255, 255, 255);
  background-color: red;
`;
